import { useQuery } from '@tanstack/react-query'

import { getUser } from '@app/api/routes/auth'

import { AUTH_QUERY_KEY } from '@app/constants/queryKeys'

import { UserDto } from '@app/api/routes/auth/dtos'

import type { AxiosError } from 'axios'
import type { ErrorResponseDto } from '@app/api/dtos'
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'

export const useUserQuery = (
  options: Omit<UseQueryOptions<UserDto, AxiosError<ErrorResponseDto>, UserDto, string[]>, 'queryKey' | 'queryFn'> = {}
): UseQueryResult<UserDto, AxiosError<ErrorResponseDto>> => {
  return useQuery({
    retry: false,
    ...options,
    queryFn: async () => await getUser(),
    queryKey: [AUTH_QUERY_KEY.authUser]
  })
}
